import { CaptionSM } from '@/atoms/Text'

interface SubmissionTipProps {
  icon: React.ReactNode
  title: string
}

export const SubmissionTip: React.FC<SubmissionTipProps> = ({ icon, title }) => {
  return (
    <div className="flex w-[48%] max-w-[280px] flex-row items-center gap-2 rounded-xl border-[1.5px] border-solid border-core-gray-300 p-3 md:w-[31%] md:flex-col md:items-start md:gap-4 md:rounded-2xl md:p-4 lg:flex-row lg:items-center lg:gap-3 se:gap-1 se:rounded-lg se:p-2">
      {icon}
      <CaptionSM
        className="se:photon-caption-xs md:photon-caption-md tracking-tighter md:tracking-normal"
        weight="bold"
      >
        {title}
      </CaptionSM>
    </div>
  )
}
